import {LAYOUT_OPTIONS_QUERY} from "@/app/exercise/components/question/core/question-const";

export const FILTERS_ARGS = {
  SEARCH: 'search',
  CATEGORY: 'category',
  LAYOUT: 'layout',
  TYPE: 'type',
  LICENSE_TYPE: 'license_type',
  TENANT: 'tenant',
  IS_AUTO: 'is_auto', // true or false
  IS_MOTOR: 'is_motor', // true or false
  IS_SCOOTER: 'is_scooter', // true or false
}

export const SORT_ARGS = {
  NAME: 'name',
  CATEGORY: 'category',
  LAYOUT: 'layout',
  ORDERING: 'ordering',
}

export const QUESTION_TYPES = {
  videoQuestions: {
    title: 'Video',
    query: 'videos',
    maxLength: 3,
  },
  theoryQuestions: {
    title: 'Theory',
    query: 'theory',
    maxLength: 3,
  },
  practiceQuestions: {
    title: 'Practice',
    query: 'questions',
    maxLength: 3,
  },
};

export const LAYOUT_ICONS = {}
LAYOUT_ICONS[LAYOUT_OPTIONS_QUERY.QUESTIONS] = 'mdi-help-circle';
LAYOUT_ICONS[LAYOUT_OPTIONS_QUERY.THEORIE] = 'mdi-information-outline';
LAYOUT_ICONS[LAYOUT_OPTIONS_QUERY.VIDEO] = 'mdi-video-outline';
LAYOUT_ICONS[LAYOUT_OPTIONS_QUERY.GEVAARHERKENNING] = 'mdi-help-circle';
LAYOUT_ICONS[LAYOUT_OPTIONS_QUERY.DRAG_AND_DROP] = 'mdi-drag-variant';
LAYOUT_ICONS[LAYOUT_OPTIONS_QUERY.NUMERIC] = 'mdi-numeric';
LAYOUT_ICONS[LAYOUT_OPTIONS_QUERY.PICTURE_SELECT] = 'mdi-image-check-outline';

export const LAYOUT_OPTIONS = [
  {
    name: 'Question',
    query: 'content_tests'
  },
  {
    name: 'Theorie',
    query: 'content'
  },
  {
    name: 'Video',
    query: 'video'
  },
  {
    name: 'Question Gevaarhrkenning',
    query: 'gevaarherkenning'
  },
]

export const LICENSE_TYPES_OPTIONS = [
  {
    name: 'Auto',
    query: 'is_auto'
  },
  {
    name: 'Motor',
    query: 'is_motor'
  },
  {
    name: 'Scooter',
    query: 'is_scooter'
  }
]

export const TENANT_OPTIONS = [
  {
    name: 'Wiki',
    query: 'wiki'
  },
  {
    name: 'Les',
    query: 'les'
  },
  {
    name: 'Online',
    query: 'online'
  }
]